// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"629":"58ddc136","2456":"6ab2a185"}[chunkId] + ".chunk.css";
};